import { Button, Upload } from 'antd'
import { DocumentNode } from 'graphql'
import { UploadListType } from 'antd/lib/upload/interface'
import { useMutation } from '@apollo/client'
import { useRecordContext } from 'react-admin'
import ImgCrop from 'antd-img-crop'
import React, { FC } from 'react'

type FileUploaderProps = {
  accept: string
  buttonProps?: { type: any }
  controlledFileList?: boolean
  imgCrop?: boolean
  imgCropProps?: { [key: string]: any }
  label?: string
  onChange: (file: File) => void
}

type FileUploaderState = {
  fileList: File[]
  uploading: boolean
}

export default class FileUploader extends React.Component<FileUploaderProps, FileUploaderState> {
  state = { fileList: [], uploading: false }

  reset = (): void => {
    this.setState({ fileList: [] })
    this.props.onChange(null)
  }

  render(): JSX.Element {
    const { fileList } = this.state
    const { accept, controlledFileList, imgCrop, imgCropProps, label, onChange } = this.props

    let uploadProps = {
      onRemove: this.reset,
      beforeUpload: (file: File) => {
        this.setState({ fileList: [file] })
        onChange(file)
        return false
      },
      accept: accept,
    }

    // when controlling fileList value, the image preview list does not include image icons
    // can only control fileList (required to programmatically clear the fileList) by setting
    // fileList value in the uploadProps
    if (controlledFileList) {
      uploadProps = Object.assign(uploadProps, { fileList: [...fileList] })
    } else {
      uploadProps = Object.assign(uploadProps, {
        defaultFileList: [...fileList],
        listType: 'picture' as UploadListType,
      })
    }

    const uploadButton = (
      <Upload {...uploadProps}>
        <Button {...this.props.buttonProps} disabled={this.state.fileList.length > 0}>
          {label || 'Upload Document'}
        </Button>
      </Upload>
    )

    return imgCrop ? <ImgCrop {...imgCropProps}>{uploadButton}</ImgCrop> : uploadButton
  }
}

interface ImageUploaderProps {
  acceptableFileTypes?: string
  actionLabel: string
  className?: string
  cropProps?: { [key: string]: any }
  mutation: DocumentNode
  onUploadComplete: () => void
  onUploadError: (e: Error) => void
  source: string
  style?: React.CSSProperties
}

export const ImageUploader: FC<ImageUploaderProps> = ({
  acceptableFileTypes = '.jpeg,.jpg,.png',
  actionLabel,
  className,
  cropProps,
  mutation,
  onUploadComplete,
  onUploadError,
  source,
  style,
}) => {
  const [uploadImage] = useMutation(mutation, { onCompleted: onUploadComplete, onError: onUploadError })

  const onChange = (logo: File): void => {
    uploadImage({ variables: { id: record.id, [source]: logo } })
  }
  const record = useRecordContext()
  if (!record) return null

  return (
    <div className={className} style={style}>
      <FileUploader
        imgCrop
        imgCropProps={cropProps}
        accept={acceptableFileTypes}
        onChange={onChange}
        label={actionLabel}
      />
    </div>
  )
}
